import { render, staticRenderFns } from "./participant-footer.vue?vue&type=template&id=653ea83c&scoped=true&"
import script from "./participant-footer.vue?vue&type=script&lang=ts&"
export * from "./participant-footer.vue?vue&type=script&lang=ts&"
import style0 from "./participant-footer.vue?vue&type=style&index=0&id=653ea83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ea83c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
